import { DiscountsList as DiscountsListComponent } from 'components/discounts/DiscountsList/DiscountsList'

export const DiscountsList: React.FC = () => {
  return <DiscountsListComponent />
}
